import React, { useCallback, useState } from 'react';

import { Snackbar } from '@material-ui/core';
import { connect } from 'react-redux';

import useClassNames from '~/hooks/use-classnames';
import useDidMount from '~/hooks/use-did-mount';
import { SIGNATURE_STATUS } from '~/values/enums';

import Button from './Button';
import Icon from './Icon';
import styles from './SubscriptionStatusMessage.module.scss';

const DISPLAY_POSITION = {
    vertical: 'bottom',
    horizontal: 'right',
};

const SubscriptionStatusMessage = ({ user, history }) => {
    const [open, setOpen] = useState(false);
    const situation = user?.cliente?.assinatura?.situacao;
    const showSnackBar = situation !== SIGNATURE_STATUS.VIGENTE;

    const subscriptionContainerClassNames = useClassNames([
        styles.containerMessage,
        { [styles.noSubscriptionContainer]: !situation },
        { [styles.pendingSubscriptionContainer]: situation === SIGNATURE_STATUS.PENDENTE },
        { [styles.expiredSubscriptionContainer]: situation === SIGNATURE_STATUS.VENCIDA },
        { [styles.canceledSubscriptionContainer]: situation === SIGNATURE_STATUS.CANCELADA },
    ]);

    const renderSituationLabel = useCallback(() => {
        if (situation === SIGNATURE_STATUS.PENDENTE) {
            return 'Sua assinatura encontra-se pendente. Aguarde mais alguns instantes para aproveitar o DHO!';
        }

        if (situation === SIGNATURE_STATUS.VENCIDA) {
            return 'Sua assinatura está vencida. Acesse a página de planos e regularize sua situação.';
        }

        if (situation === SIGNATURE_STATUS.CANCELADA) {
            return 'Sua assinatura foi cancelada. Acesse a página de planos e regularize sua situação.';
        }

        return 'Parece que você não tem assinatura. Contrate um plano e continue aproveitando o DHO!';
    }, [situation]);

    useDidMount(() => {
        setOpen(true);
    });

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    const handleRedirect = useCallback(() => {
        history.push('/app/assinatura');
        handleClose();
    }, [handleClose, history]);

    return (
        showSnackBar ? (
            <Snackbar
                open={open}
                anchorOrigin={DISPLAY_POSITION}
            >
                <div className={subscriptionContainerClassNames}>
                    <div className={styles.subscriptionMessage}>
                        <Icon
                            name="warning"
                            className={styles.icon}
                        />
                        {' '}
                        {renderSituationLabel()}
                    </div>
                    <div className={styles.checkPlansButton}>
                        <Button
                            size="small"
                            onClick={handleClose}
                            color="textSecondaryDark"
                        >
                            Cancelar
                        </Button>
                        <Button
                            size="small"
                            color="primary"
                            onClick={handleRedirect}
                        >
                            Ver planos
                        </Button>
                    </div>
                </div>
            </Snackbar>
        ) : null);
};

const mapStateToProps = ({ user }) => {
    return {
        user,
    };
};

export default connect(mapStateToProps)(SubscriptionStatusMessage);
